// extracted by mini-css-extract-plugin
export default {"body":"Menu_body__o03uG","menuButton":"Menu_menuButton__bXk+y","menu":"Menu_menu__EElTr","header":"Menu_header__aneib"};